import { useEffect, useRef, useState } from 'react';
import HeaderImage from './HeaderImage';
import HeaderSlider from './HeaderSlider';
import HeaderVideo from './HeaderVideo';
import Bar from '@/components/platform/Bar';
import { PrettySection } from '@/components/ui/Section/PrettySection';

const COMPONENTS = {
  image: HeaderImage,
  video: HeaderVideo,
  slider: HeaderSlider,
};

const getHeaderComponent = (content) => {
  const componentKey = Object.keys(content).filter(function (key) {
    if (COMPONENTS[key]) return COMPONENTS[key];
  });

  if (!componentKey) {
    console.error(`Component ${componentKey} doesn't exist.`);
    return false;
  }

  return COMPONENTS[componentKey];
};

export default function DynamicHeader({
  content,
  clientKey,
  logo,
  showSwordLogo = true,
  redirectToApp = true,
  userName,
  topBanner,
  scrollTop,
}) {
  const ref = useRef(null);
  const [distanceToTop, setDistanceToTop] = useState(0);
  const [barHeight, setBarHeight] = useState(0);

  useEffect(() => {
    if (!!content && ref?.current && topBanner) {
      setBarHeight(ref.current.getBoundingClientRect().height);
      setDistanceToTop(ref.current.getBoundingClientRect().top);
    }
  }, []);

  if (!content) {
    console.error("Please provide a 'content' property to the DynamicHeader");
    return;
  }

  const Component = getHeaderComponent(content);

  if (!Component) {
    return '';
  } else {
    return (
      <>
        <Bar
          clientKey={clientKey}
          refBar={ref}
          showSwordLogo={showSwordLogo}
          logos={Array.isArray(logo) ? logo : logo?.data}
          topBanner={topBanner}
          scrollTop={scrollTop}
          buttonLabel={content?.content?.button?.label}
        />
        <PrettySection md="0" sm="0" {...Component?.defaultConfig} {...content?.config}>
          <Component
            content={content}
            logo={logo}
            showSwordLogo={showSwordLogo}
            redirectToApp={redirectToApp}
            userName={userName}
            distanceToTop={distanceToTop}
            barHeight={barHeight}
          />
        </PrettySection>
      </>
    );
  }
}
